import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ChatAction, ChatSettlement, ChatSnapshot, ChatSubmission } from "./model.ts";
export class ChatBrowserIo extends Context.Service<ChatBrowserIo, {
  readonly linkedThread: Effect.Effect<string | null>;
}>()("workerstation/frontend/ChatBrowserIo") {}
export interface ChatInput {
  readonly stationId: string;
  readonly invalidate: Effect.Effect<void>;
}
export interface ChatSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ChatSnapshot>>;
  readonly read: Effect.Effect<ChatSnapshot>;
  readonly settlements: Effect.Effect<{ readonly total: number; readonly recent: readonly ChatSettlement[] }>;
  readonly receive: (input: ChatInput) => Effect.Effect<void>;
  readonly dispatch: (action: ChatAction) => Effect.Effect<void>;
  readonly send: (submission: ChatSubmission) => Effect.Effect<boolean>;
}
export class ChatSessions extends Context.Service<ChatSessions, {
  readonly open: Effect.Effect<ChatSession, never, Scope.Scope>;
}>()("workerstation/frontend/ChatSessions") {}
